import enUS from "./en-US.json";
import zhCN from "./zh-CN.json";

export default {
  "en-US": enUS,
  "zh-CN": zhCN,
};
